export default __webpack_public_path__ + "static/media/background.c7b341e1.jpg";